import styled from "styled-components";

const HeaderLinks = styled.div`
  font-family: ${({ theme }) => theme.fonts.link.family};
  text-decoration: none;
  padding: 0 32px;
  height: 100%;
  display: flex;
  gap: 16px;
  justify-content: flex-end;

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    display: none;
  }
`;

export default HeaderLinks;
